import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, useMediaQuery } from "../../../Styles";
import { CheckBox, CheckStyles } from "../..";
import { DataObj, getLabelFromKey, ReportTemplate } from "../../../Definitions";

interface Lvl3_Props {
  templateData?: ReportTemplate
  onTemplateDataChange: (data: ReportTemplate) => void
}

export default function TemplateModalLvl3({ templateData, onTemplateDataChange }: Lvl3_Props) {
  const {t} = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 690px)`);

  const checkboxes = useMemo(() => {
    const dataParameters: DataObj[] = [
      // "locationId", 
      "animal_group_id", 
      // "conditionId", 
      // "attentionId", 
      "milestone_id"
    ];

    return dataParameters.map((param, index) => {
      const label = getLabelFromKey(param);
      
      return (
        <CheckBox
          key={index}
          text={t(`params.${label}`, {defaultValue: `${label}`})}
          checkStyle={CheckStyles.blue}
          isChecked={templateData?.dataParameter?.includes(param)}
          onChange={() => {
            const isChecked = templateData?.dataParameter?.includes(param);
            const updatedParams = isChecked
              ? templateData && templateData.dataParameter?.filter(id => id !== (param))
              : [...(templateData?.dataParameter || []), param];
              onTemplateDataChange({ ...templateData, templateId: templateData?.templateId || 0, dataParameter: updatedParams });
          }}
        />
      );
    });
  }, [onTemplateDataChange, templateData, t]);
  
  return (
    <div style={{ width: "fit-content", display: "flex", flexWrap: "wrap", columnGap: "60px", rowGap: "10px", margin: "0 auto", flexDirection: mobileXs ? "column" : "row" }}>  
      {checkboxes}
    </div>
  )
}